import styled from 'styled-components';
import { SlideOver } from 'ui/slideOver';
import { SlideOverContent, SlideOverHeader } from 'ui/slideOver/SlideOver.styled';
import { heading4, smallShadow, spacing } from 'ui/theme';

export const AlertsHistorySlideOverHeader = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusQuarter};
`;

export const SlideOverHeaderTitle = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  height: ${spacing.doubleQuarter};

  ${heading4};
  line-clamp: 2;
`;

export const StyledSlideOver = styled(SlideOver)<{ $withPadding: boolean }>`
  ${SlideOverContent} {
    ${({ $withPadding }) => ($withPadding ? '' : `padding: 0;`)}
  }

  && ${SlideOverHeader} {
    ${smallShadow};
  }
`;
